<template>
    <div class="amanah">
        <div class="page">
            <div class="subpage">
                <div class="title">PERATURAN TRANSAKSI (TRADING RULES) MULTILATERAL (MT5) PT ABI KOMODITI BERJANGKA</div>
                <div class="content">
                    <ol>
                        <li class="menu">
                            KETENTUAN UTAMA
                            <div class="sub-menu">
                                Peraturan transaksi (Trading Rules) komoditi multilateral (GOFX) ini mengacu dan tunduk pada Peraturan Bursa Komoditi dan Derivatif
                                Indonesia (BKDI/ICDX) dan/atau ketentuan dalam Peraturan Indonesia Clearing House (ICH) sepanjang tidak ditentukan secara khusus
                                diperaturan ini.
                            </div>
                        </li>
                        <li class="menu">
                            MEKANISME TRANSAKSI
                            <div class="sub-menu">
                                Transaksi dilakukan melalui sistem elektronik (Online) yang disediakan oleh Bursa Komoditi dan Derivative Indonesia (BKDI/ICDX) yaitu
                                Meta Trader 5 (MT5).
                            </div>
                        </li>
                        <li class="menu">
                            MARGIN CALL
                            <div class="sub-menu">
                                <ol type="a">
                                    <li>
                                        Margin Call akan dilakukan jika pada saat jam perdagangan, floating loss dari posisi transaksi nasabah yang masih
                                        terbuka/open menyentuh/mencapai range 70% terhadap current balance/equity yang ada (berdasarkan harga bid dan ask);
                                    </li>
                                    <li>
                                        Pemberitahuan perihal margin call disampaikan melalui alert di trading sistem Meta Trader 5 (MT5).
                                    </li>
                                </ol>
                            </div>
                        </li>
                        <li class="menu">
                            AUTO CUT EQUITY
                            <div class="sub-menu">
                                <ol type="a">
                                    <li>
                                        Apabila equity Nasabah turun mencapai 30% atau kurang dari Margin Requirement per lot, maka secara otomatis sistem akan
                                        melikuidasi sebagian atau seluruh posisi Nasabah tanpa perlu mendapat persetujuan dari Nasabah terlebih dahulu;
                                    </li>
                                    <li>
                                        Penentuan angka autocut adalah berdasarkan harga bid dan ask yang ada di sistem Meta Trade 5 (MT5);
                                    </li>
                                    <li>
                                        PT. ABI Komoditi Berjangka tidak bertanggung jawab akibat kerugian yang dialami nasabah;
                                    </li>
                                    <li>Apabila terjadi kekurangan margin maupun overloss maka semua kerugian yang timbul akan menjadi tanggung jawab nasabah;</li>
                                    <li>Nasabah wajib melunasi kekurangan margin maupun over loss (contohnya : jika terjadi Open Gap).</li>
                                </ol>
                            </div>
                        </li>
                        <li class="menu">
                            PENAMBAHAN DANA/ MARGIN IN
                            <div class="sub-menu">
                                Apabila Nasabah ingin melakukan penambahan dana di akunnya, Nasabah dapat menyetor dana ke Rekening Terpisah PT. ABI Komoditi
                                Berjangka yang dicantumkan di Aplikasi Pembukaan Akun.
                            </div>
                        </li>
                        <li class="menu">
                            PENARIKAN DANA/ WITHDRAWAL/ MARGIN OUT
                            <div class="sub-menu">
                                Pengajuan penarikan dana akan diproses pada hari yang sama jika diterima sebelum pukul 11:00 WIB, kecuali hari libur
                                nasional/perbankan. Untuk pengajuan penarikan dana setelah pukul 11:00 WIB, akan diproses keesokan harinya kecuali hari libur
                                nasional/perbankan. Jika dalam proses penarikan dana terdapat biaya bank, maka biaya bank tersebut akan dibebankan kepada Nasabah.
                            </div>
                        </li>
                        <li class="menu">
                            PELAKSANAAN ORDER TRANSAKSI
                            <div class="sub-menu">
                                <ol type="a">
                                    <li>
                                        Penyampaian Order
                                        <ul style="margin-left: 18px;">
                                            <li>Penyampaian order dilaksanakan dengan online system Meta Trader 5 (MT5);</li>
                                            <li>
                                                Harga transaksi yang terjadi adalah harga yang ada di market system Meta Trader 5 (MT5) di Bursa Komoditi Dan
                                                Derivative Indonesia (BKDI/ICDX).
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        Jenis Order
                                        <ul style="margin-left: 18px;">
                                            <li>
                                                <b> Pending Order, </b>Digunakan untuk melakukan transaksi dengan menentukan harga yang diinginkan:
                                                <ul style="margin-left: 18px;">
                                                    <li>
                                                        <b>Return</b>
                                                        ( Jika harga pada market ASK 500 lot, sementara transaksi adalah BUY 600 lot, maka order akan menjadi 500 lot
                                                        done, dan 100 lot akan menjadi pending order );
                                                    </li>
                                                    <li>
                                                        <b>Fill Or Kill</b> (Jika ada transaksi BUY 500 lot, sementara yang ada di market ASK 400 lot, maka order
                                                        tersebut tidak diterima (No liquidity));
                                                    </li>
                                                    <li>
                                                        <b>Immediate Or Cancel</b> ( Jika harga pada market ASK 500 lot, sementara transaksi BUY 600 lot, maka order
                                                        akan menjadi 500 lot done, tetapi 100 lot sisanya akan auto cancel);
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <b>Exchange Execution</b>, Digunakan untuk melakukan transaksi tanpa menentukan harga, tetapi sesuai dengan harga
                                                penawaran dan jumlah lot yang tersedia di market;
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        Masa berlaku Pending Order, Pada saat pasar dibuka (market open) dan berakhir pada saat pasar ditutup (market close), sesuai
                                        jam transaksi di bursa.
                                    </li>
                                </ol>
                            </div>
                        </li>
                        <li class="menu">
                            LAPORAN HARIAN NASABAH
                            <div class="sub-menu">
                                <ol type="a">
                                    <li>
                                        Nasabah dapat mengakses Laporan Keuangan secara langsung, melalui Sistem Meta Trader 5 (MT5) secara online; namun Laporan
                                        Keuangan resmi adalah yang diterbitkan oleh Settlement PT. ABI Kommodity Berjangka
                                    </li>
                                    <li>
                                        Nasabah harus mereview dan melaporkan dengan segera jika ditemukan ketidaksesuaian yang terdapat pada laporan yang
                                        diterbitkan oleh Settlement PT. ABI Komoditi Berjangka;
                                    </li>
                                    <li>
                                        Segala pelaporan dalam Sistem tersebut akan dianggap telah setuju apabila PT. ABI Komoditi Berjangka tidak menerima
                                        pemberitahuan melalui telepon dan disusul dengan pemberitahuan tertulis selambat-lambatnya 2 (dua) hari kerja dari tanggal
                                        Laporan Keuangan nasabah tersebut;
                                    </li>
                                    <li>
                                        Bilamana dalam waktu 2 (dua) hari kerja sejak tanggal Laporan Keuangan nasabah tersebut dikeluarkan tidak ada sanggahan dari
                                        nasabah atau pemberitahuan kepada PT. ABI Komoditi Berjangka atas setiap ketidaksesuaian akan mengakibatkan nasabah menerima
                                        Laporan Keuangan tersebut seperti yang tertulis didalamnya maka Laporan Keuangan nasabah tersebut dianggap benar dan sah
                                    </li>
                                </ol>
                            </div>
                        </li>
                        <li class="menu">
                            KERAHASIAAN
                            <div class="sub-menu">
                                Setiap nasabah akan mendapatkan User ID dan Password yang dikirim melalui e-mail nasabah. Fungsinya adalah sebagai hak akses ke
                                Fasilitas Platform Meta Trader 5 (MT5). Nasabah disarankan mengganti password tersebut sebelum memulai transaksi. User ID dan
                                Password bersifat rahasia dan hanya diketahui oleh nasabah. dimana pejabat atau karyawan PT. ABI Komoditi Berjangka pun tidak
                                mengetahuinya. PT. ABI Komoditi Berjangka tidak bertanggungjawab atas segala hal yang terjadi akibat penggunaan user id dan password
                                oleh pihak lain selain nasabah.
                            </div>
                        </li>
                        <li class="menu">
                            PERSELISIHAN
                            <div class="sub-menu">
                                <ol type="a">
                                    <li>
                                        Pembuktian atas fakta-fakta, di mana fakta-fakta tersebut dapat dilihat antara lain di dalam historis transaksi, report, dan
                                        data-data pendukung lainnya;
                                    </li>
                                    <li>
                                        Mengacu pada data-data terakhir yang tercatat di PT. ABI Komoditi Berjangka dan sesuai dengan ketentuan-ketentuan yang ada di
                                        dalam Trading Rules;
                                    </li>
                                    <li>
                                        Jika ada pengaduan atau keluah, nasabah dapat mengisi Formulir Pengaduan Nasabag dan mengajukan kepada Bagian compliance PT.
                                        ABI Komoditi Berjangka.
                                    </li>
                                </ol>
                            </div>
                        </li>
                        <li class="menu">
                            FORMULA PERHITUNGAN PROFIT LOSS
                            <div class="sub-menu">
                                <b> <i>Profit (Loss) = (Harga Jual – Harga Beli) x Contract Size x Jumlah Lot</i> </b> <br />
                                Khusus transaksi di produk USDJPY, USDCHF, USDCAD: <br />
                                Perhitungan Profit (Loss) masih dalam mata uang JPY, CHF dan CAD, dan akan dikonversi menjadi USD sesuai permintaan nasabah setelah
                                transaksi ditutup. Kurs yang digunakan untuk konversi menjadi USD mengikuti kurs yang ditetapkan oleh PT. Indonesia Clearing House
                                (ICH) pada hari permintaan nasabah. Oleh karena itu, ada kemungkinan timbul perbedaan antara angka USD final setelah konversi dengan
                                angka yang ditampilkan oleh system Meta Trader 5, dan atas perbedaan itu akan dilakukan ADJUSTMENT.
                            </div>
                        </li>
                        <li class="menu">
                            SPESIFIKASI KONTRAK
                            <div class="sub-menu">
                                Spesifikasi kontrak dari produk yang diperdagangkan, yang merupakan bagian yang tidak terpisahkan dari peraturan ini terdapat di
                                lampiran.
                            </div>
                        </li>
                        <li class="menu">
                            LAIN-LAIN
                            <div class="sub-menu">
                                <ol type="a">
                                    <li>
                                        Harga yang ada di Platform sistem Meta Trader 5 terbentuk oleh Market;
                                    </li>
                                    <li>
                                        Apabila terjadi harga diluar batas perubahan harga pada Platform Meta Trader 5 (MT5) maka transaksi akan berhenti (Suspend
                                        Bursa) atau batas tersebut dapat diperlebar oleh Bursa sesuai ketentuan yang ada di bursa;
                                    </li>
                                    <li>
                                        Waktu yang digunakan pada sistem adalah WIB;
                                    </li>
                                    <li>
                                        Platform sistem Meta Trader 5 (MT5) dilaksanakan melalui Sistem Elektronik, karena itu nasabah dapat menghadapi risiko yang
                                        berkaitan dengan Sistem tersebut. Kegagalan dengan perangkat keras atau perangkat lunak atau terganggunya koneksi internet
                                        berakibat transaksi tidak dapat dilaksanakan sesuai dengan perintah nasabah. Dan seluruh akibat dari kegagalan sistem
                                        elektronik tersebut akan menjadi tanggungjawab nasabah sendiri;
                                    </li>
                                    <li>
                                        Keadaan Hectic Market, Adalah keadaan ketika pasar dalam kondisi yang tidak normal /atau tidak menentu. Pada situasi ini
                                        spread akan didasarkan pada kondisi pergerakan harga sebagaimana quotasi yang ditampilkan di Meta Trader 5. Yang dimaksud
                                        dengan kondisi hectic apabila dipenuhi minimal salah satu dari situasi sebagai berikut :
                                        <ul style="margin-left: 18px">
                                            <li>bid atau offer hanya ada satu sisi;</li>
                                            <li>
                                                Adanya berita politik, ekonomi, terorisme, bencana alam dan hal-hal lain yang mempengaruhi kondisi pasar finansial;
                                            </li>
                                            <li>Kondisi diatas bukan disebabkan oleh wrong quote.</li>
                                        </ul>
                                    </li>
                                    <li>
                                        Trading Rules ini dapat diubah dan akan diberitahukan kepada nasabah melalui Surat Pemberitahuan;
                                    </li>
                                </ol>
                            </div>
                        </li>
                    </ol>
                    <div class="wrap-statement text-center">
                        <div class="statement">
                            Saya menyatakan bahwa saya telah menerima
                            <div><b>PERATURAN TRANSAKSI KOMODITI MULTILATERAL PT. ABI Komoditi Berjangka</b></div>
                            Mengerti dan Menyetujui isinya.
                        </div>
                        <div class="ttd">
                            <img :src="dataPrint.tandaTangan" alt="" />
                            <div class="name-nasabah">{{ dataPrint.fullname }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page">
            <div class="subpage">
                <div class="content-table">
                    <h6 class="text-center mb-4">FOREX CONTRACT SPECIFICATION (MINI)</h6>
                    <div style="overflow-x:auto">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Symbol</th>
                                    <th>AUD/USD</th>
                                    <th>EUR/USD</th>
                                    <th>GBP/USD</th>
                                    <th>NZD/USD</th>
                                    <th>USD/CAD</th>
                                    <th>USD/CHF</th>
                                    <th>USD/JPY</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Contract Mounth</td>
                                    <td colspan="7"></td>
                                </tr>
                                <tr>
                                    <td>Contract Size</td>
                                    <td>AUD 10.000</td>
                                    <td>EUR 10.000</td>
                                    <td>GBP 10.000</td>
                                    <td>NZD 10.000</td>
                                    <td>USD 10.000</td>
                                    <td>USD 10.000</td>
                                    <td>USD 10.000</td>
                                </tr>
                                <tr>
                                    <td>Trading Day & Trading Hours</td>
                                    <td colspan="7">Monday - Friday : 06.00 - 04.30 GMT +7 (06.00 - 03.30 GMT +7 during Daylight Saving Time)</td>
                                </tr>
                                <tr>
                                    <td>Last Trading Day</td>
                                    <td colspan="7"></td>
                                </tr>
                                <tr>
                                    <td>Quality</td>
                                    <td colspan="7"></td>
                                </tr>
                                <tr>
                                    <td>Price Quotation</td>
                                    <td colspan="4">US Dollar (USD)</td>
                                    <td>Canadian Dollar (CAD)</td>
                                    <td>Swiss Franc (CHF)</td>
                                    <td>Japanese Yen (JPY)</td>
                                </tr>
                                <tr>
                                    <td>Tick Size</td>
                                    <td colspan="4">0,00001 (USD 0,1 per lot)</td>
                                    <td>0,00001 (CAD 0,1 per lot)</td>
                                    <td>0,00001 (CHF 0,1 per lot)</td>
                                    <td>0,001 (JPY 10 per lot)</td>
                                </tr>
                                <tr>
                                    <td>Daily Price Limit</td>
                                    <td colspan="7"></td>
                                </tr>
                                <tr>
                                    <td>Settlement Price</td>
                                    <td colspan="7" class="text-left">
                                        <ol>
                                            <li>
                                                Daily settlement price is determined by refering to the last trade price from price reference by Exchange (ICDX) and
                                                Clearing (ICH)
                                            </li>
                                            <li>Price reference will be announced through circular letter</li>
                                        </ol>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Financing Rate</td>
                                    <td colspan="7"></td>
                                </tr>
                                <tr>
                                    <td>Rollover Rate</td>
                                    <td colspan="7">Rollover Rate will be announced by Exchange (ICDX) and Clearing (ICH)</td>
                                </tr>
                                <tr>
                                    <td>Margin</td>
                                    <td colspan="7">1,5% (announced by Exchange (ICDX) and Clearing (ICH))</td>
                                </tr>
                                <tr>
                                    <td>Position Limit</td>
                                    <td colspan="7">5.000 lot</td>
                                </tr>
                                <tr>
                                    <td>Position To Be Reported</td>
                                    <td colspan="7">2.500 lot</td>
                                </tr>
                                <tr>
                                    <td>Settlement Method</td>
                                    <td colspan="7">Cash Settlement</td>
                                </tr>
                                <tr>
                                    <td>Rate (based on Clearing - ICH)</td>
                                    <td colspan="4">USD Floating</td>
                                    <td>CAD Floating</td>
                                    <td>CHF Floating</td>
                                    <td>JPY Floating</td>
                                </tr>
                                <tr>
                                    <td>Commission Charge</td>
                                    <td colspan="7">USD 3 lot/side</td>
                                </tr>
                                <tr>
                                    <td>Margin Deposit</td>
                                    <td colspan="7">IDR 10.000.000</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="page">
            <div class="subpage">
                <div class="content-table">
                    <h6 class="text-center mb-4">FOREX CONTRACT SPECIFICATION (MICRO)</h6>
                    <div style="overflow-x:auto">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Symbol</th>
                                    <th>AUD/USDMic</th>
                                    <th>EUR/USDMic</th>
                                    <th>GBP/USDMic</th>
                                    <th>NZD/USDMic</th>
                                    <th>USD/CADMic</th>
                                    <th>USD/CHFMic</th>
                                    <th>USD/JPYMic</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Contract Mounth</td>
                                    <td colspan="7"></td>
                                </tr>
                                <tr>
                                    <td>Contract Size</td>
                                    <td>AUD 1.000</td>
                                    <td>EUR 1.000</td>
                                    <td>GBP 1.000</td>
                                    <td>NZD 1.000</td>
                                    <td>USD 1.000</td>
                                    <td>USD 1.000</td>
                                    <td>USD 1.000</td>
                                </tr>
                                <tr>
                                    <td>Trading Day & Trading Hours</td>
                                    <td colspan="7">Monday - Friday : 06.00 - 04.30 GMT +7 (06.00 - 03.30 GMT +7 during Daylight Saving Time)</td>
                                </tr>
                                <tr>
                                    <td>Last Trading Day</td>
                                    <td colspan="7">-</td>
                                </tr>
                                <tr>
                                    <td>Quality</td>
                                    <td colspan="7">-</td>
                                </tr>
                                <tr>
                                    <td>Price Quotation</td>
                                    <td colspan="4">US Dollar (USD)</td>
                                    <td>Canadian Dollar (CAD)</td>
                                    <td>Swiss Franc (CHF)</td>
                                    <td>Japanese Yen (JPY)</td>
                                </tr>
                                <tr>
                                    <td>Tick Size</td>
                                    <td colspan="4">0,00001 (USD 0,01 per lot)</td>
                                    <td>0,00001 (CAD 0,01 per lot)</td>
                                    <td>0,00001 (CHF 0,01 per lot)</td>
                                    <td>0,001 (JPY 1 per lot)</td>
                                </tr>
                                <tr>
                                    <td>Daily Price Limit</td>
                                    <td colspan="7"></td>
                                </tr>
                                <tr>
                                    <td>Settlement Price</td>
                                    <td colspan="7" class="text-left">
                                        <ol>
                                            <li>
                                                Daily settlement price is determined by refering to the last trade price from price reference by Exchange (ICDX) and
                                                Clearing (ICH)
                                            </li>
                                            <li>Price reference will be announced through circular letter</li>
                                        </ol>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Financing Rate</td>
                                    <td colspan="7"></td>
                                </tr>
                                <tr>
                                    <td>Rollover Rate</td>
                                    <td colspan="7">Rollover Rate will be announced by Exchange (ICDX) and Clearing (ICH)</td>
                                </tr>
                                <tr>
                                    <td>Margin</td>
                                    <td colspan="7">1,5% (announced by Exchange (ICDX) and Clearing (ICH))</td>
                                </tr>
                                <tr>
                                    <td>Position Limit</td>
                                    <td colspan="7">50.000 lot</td>
                                </tr>
                                <tr>
                                    <td>Position To Be Reported</td>
                                    <td colspan="7">25.000 lot</td>
                                </tr>
                                <tr>
                                    <td>Settlement Method</td>
                                    <td colspan="7">Cash Settlement</td>
                                </tr>
                                <tr>
                                    <td>Rate (based on Clearing - ICH)</td>
                                    <td colspan="4">USD Floating</td>
                                    <td>CAD Floating</td>
                                    <td>CHF Floating</td>
                                    <td>JPY Floating</td>
                                </tr>
                                <tr>
                                    <td>Commission Charge</td>
                                    <td colspan="7">USD 1 lot/side</td>
                                </tr>
                                <tr>
                                    <td>Margin Deposit</td>
                                    <td colspan="7">IDR 1.000.000</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="page">
            <div class="subpage">
                <div class="content-table">
                    <h6 class="text-center mb-4">CROSS CURRENCY CONTRACT SPECIFICATION</h6>
                    <div style="overflow-x:auto">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Symbol</th>
                                    <th>EUR/JPY</th>
                                    <th>GBP/JPY</th>
                                    <th>EUR/JPYMic</th>
                                    <th>GBPJPYMic</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Contract Mounth</td>
                                    <td colspan="4"></td>
                                </tr>
                                <tr>
                                    <td>Contract Size</td>
                                    <td>EUR 10.000</td>
                                    <td>GBP 10.000</td>
                                    <td>EUR 1.000</td>
                                    <td>GBP 1.000</td>
                                </tr>
                                <tr>
                                    <td>Trading Day & Trading Hours</td>
                                    <td colspan="4">Monday - Friday : 06.00 - 04.30 GMT +7 (06.00 - 03.30 GMT +7 during Daylight Saving Time)</td>
                                </tr>
                                <tr>
                                    <td>Last Trading Day</td>
                                    <td colspan="4"></td>
                                </tr>
                                <tr>
                                    <td>Quality</td>
                                    <td colspan="4"></td>
                                </tr>
                                <tr>
                                    <td>Price Quotation</td>
                                    <td colspan="4">Japanese Yen (JPY)</td>
                                </tr>
                                <tr>
                                    <td>Tick Size</td>
                                    <td colspan="2">0,001 (JPY 10 per lot)</td>
                                    <td colspan="2">0,001 (JPY 1 per lot)</td>
                                </tr>
                                <tr>
                                    <td>Daily Price Limit</td>
                                    <td colspan="4"></td>
                                </tr>
                                <tr>
                                    <td>Settlement Price</td>
                                    <td colspan="4" class="text-left">
                                        <ol>
                                            <li>
                                                Daily settlement price is determined by refering to the last trade price from price reference by Exchange (ICDX) and
                                                Clearing (ICH)
                                            </li>
                                            <li>Price reference will be announced through circular letter</li>
                                        </ol>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Financing Rate</td>
                                    <td colspan="4"></td>
                                </tr>
                                <tr>
                                    <td>Rollover Rate</td>
                                    <td colspan="4">Rollover Rate will be announced by Exchange (ICDX) and Clearing (ICH)</td>
                                </tr>
                                <tr>
                                    <td>Margin</td>
                                    <td colspan="4">1,5% (announced by Exchange (ICDX) and Clearing (ICH))</td>
                                </tr>
                                <tr>
                                    <td>Position Limit</td>
                                    <td colspan="2">5.000 lot</td>
                                    <td colspan="2">50.000 lot</td>
                                </tr>
                                <tr>
                                    <td>Position To Be Reported</td>
                                    <td colspan="2">2.500 lot</td>
                                    <td colspan="2">25.000 lot</td>
                                </tr>
                                <tr>
                                    <td>Settlement Method</td>
                                    <td colspan="7">Cash Settlement</td>
                                </tr>
                                <tr>
                                    <td>Rate (based on Clearing - ICH)</td>
                                    <td colspan="4">JPY Floating</td>
                                </tr>
                                <tr>
                                    <td>Commission Charge</td>
                                    <td colspan="2">USD 3 per lot/side</td>
                                    <td colspan="2">USD 1 per lot/side</td>
                                </tr>
                                <tr>
                                    <td>Margin Deposit</td>
                                    <td colspan="2">IDR 10.000.000</td>
                                    <td colspan="2">IDR 1.000.000</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="page">
            <div class="subpage">
                <div class="content-table">
                    <h6 class="text-center mb-4">CRUDE OIL CONTRACT SPECIFICATION</h6>
                    <div style="overflow-x:auto">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Symbol</th>
                                    <th>EUR/JPY</th>
                                    <th>GBP/JPY</th>
                                    <th>EUR/JPYMic</th>
                                    <th>GBPJPYMic</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Contract Mounth</td>
                                    <td colspan="4">
                                        3 (three) consecutive contract months and 2 (two) closest contract months thereafter (March, May July September, December)
                                    </td>
                                </tr>
                                <tr>
                                    <td>Contract Size</td>
                                    <td>100 Barrel per lot</td>
                                    <td>10 Barrel per lot</td>
                                    <td>100 Barrel per lot</td>
                                    <td>10 Barrel per lot</td>
                                </tr>
                                <tr>
                                    <td>Trading Day & Trading Hours</td>
                                    <td colspan="4">Monday - Friday : 06.00 - 04.30 GMT +7 (06.00 - 03.30 GMT +7 during Daylight Saving Time)</td>
                                </tr>
                                <tr>
                                    <td>Last Trading Day</td>
                                    <td colspan="4">
                                        1 (One) business day before the Last Trading Day of WTI Crude Oil Futures Contract in New York Mercantile Exchange (NYMEX)
                                    </td>
                                </tr>
                                <tr>
                                    <td>Quality</td>
                                    <td colspan="4">The quality of WTI Crude Oil Futures Contract in New York Mercantile Exchange (NYMEX)</td>
                                </tr>
                                <tr>
                                    <td>Price Quotation</td>
                                    <td colspan="2">Rupiah per Barrel</td>
                                    <td colspan="2">USD per Barrel</td>
                                </tr>
                                <tr>
                                    <td>Tick Size</td>
                                    <td colspan="2">IDR 100 per Barrel</td>
                                    <td colspan="2">USD 0,01 per Barrel</td>
                                </tr>
                                <tr>
                                    <td>Daily Price Limit</td>
                                    <td colspan="4" class="text-center">4% from previous daily settlement price</td>
                                </tr>
                                <tr>
                                    <td>Settlement Price</td>
                                    <td colspan="4" class="text-left">
                                        <div>
                                            <b>Daily Settlement Price</b>
                                        </div>
                                        <div>
                                            Volume Weighted Average Price (VWAP) of all transactions in the exchange on the last 5 minutes before closing on the
                                            Trading Day
                                        </div>
                                        <div>
                                            <b>Final Settlement Price</b>
                                        </div>
                                        <div>
                                            Settlement Price of WTI Crude Oil futures contract in NYMEX that has been converted using rate determined by Clearing
                                            House
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Financing Rate</td>
                                    <td colspan="4"></td>
                                </tr>
                                <tr>
                                    <td>Rollover Rate</td>
                                    <td colspan="4"></td>
                                </tr>
                                <tr>
                                    <td>Margin</td>
                                    <td colspan="4">2,5% (announced by Exchange (ICDX) and Clearing (ICH))</td>
                                </tr>
                                <tr>
                                    <td>Position Limit</td>
                                    <td>1.500 lot</td>
                                    <td>15.000 lot</td>
                                    <td>1.500 lot</td>
                                    <td>15.000 lot</td>
                                </tr>
                                <tr>
                                    <td>Position To Be Reported</td>
                                    <td>750 lot</td>
                                    <td>7.500 lot</td>
                                    <td>750 lot</td>
                                    <td>7.500 lot</td>
                                </tr>
                                <tr>
                                    <td>Settlement Method</td>
                                    <td colspan="4">Cash Settlement</td>
                                </tr>
                                <tr>
                                    <td>Rate (based on Clearing - ICH)</td>
                                    <td colspan="2">-</td>
                                    <td colspan="2">USD Floating</td>
                                </tr>
                                <tr>
                                    <td>Commission Charge</td>
                                    <td>USD 3 per lot/side</td>
                                    <td>USD 1 per lot/side</td>
                                    <td>USD 3 per lot/side</td>
                                    <td>USD 1 per lot/side</td>
                                </tr>
                                <tr>
                                    <td>Margin Deposit</td>
                                    <td>IDR 10.000.000</td>
                                    <td>IDR 1.000.000</td>
                                    <td>IDR 10.000.000</td>
                                    <td>IDR 1.000.000</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="page">
            <div class="subpage">
                <div class="content-table">
                    <h6 class="text-center mb-4">GOLD CONTRACT SPECIFICATION</h6>
                    <div style="overflow-x:auto">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Symbol</th>
                                    <th>GOLDUD</th>
                                    <th>GOLDUDMic</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Contract Mounth</td>
                                    <td colspan="2"></td>
                                </tr>
                                <tr>
                                    <td>Contract Size</td>
                                    <td>10 troy ounce per lot</td>
                                    <td>1 troy ounce per lot</td>
                                </tr>
                                <tr>
                                    <td>Trading Day & Trading Hours</td>
                                    <td colspan="2">Monday - Friday : 06.00 - 04.30 GMT +7 (06.00 - 03.30 GMT +7 during Daylight Saving Time)</td>
                                </tr>
                                <tr>
                                    <td>Last Trading Day</td>
                                    <td colspan="2"></td>
                                </tr>
                                <tr>
                                    <td>Quality</td>
                                    <td colspan="2">Loco London Gold (LBMA Minimum Purity Standard)</td>
                                </tr>
                                <tr>
                                    <td>Price Quotation</td>
                                    <td colspan="2">US Dollar (USD)</td>
                                </tr>
                                <tr>
                                    <td>Tick Size</td>
                                    <td>USD 0,1 per troy ounce (USD 1 per lot)</td>
                                    <td>USD 0,1 per troy ounce ( USD 0,1 per lot)</td>
                                </tr>
                                <tr>
                                    <td>Daily Price Limit</td>
                                    <td colspan="2"></td>
                                </tr>
                                <tr>
                                    <td>Settlement Price</td>
                                    <td colspan="2" class="text-left">
                                        <ol>
                                            <li>Daily Settlement Price is determined by referring to a price reference at the end of GOLDUD trading day</li>
                                            <li>Price Reference is Loco London price at the end of GOLDUD trading day</li>
                                        </ol>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Financing Rate</td>
                                    <td colspan="2"></td>
                                </tr>
                                <tr>
                                    <td>Rollover Rate</td>
                                    <td colspan="2">Rollover Rate will be announced by Exchange (ICDX) and Clearing (ICH)</td>
                                </tr>
                                <tr>
                                    <td>Margin</td>
                                    <td colspan="2">1,5% (announced by Exchange (ICDX) and Clearing (ICH))</td>
                                </tr>
                                <tr>
                                    <td>Position Limit</td>
                                    <td>5.000 lot</td>
                                    <td>50.000 lot</td>
                                </tr>
                                <tr>
                                    <td>Position To Be Reported</td>
                                    <td>2.500 lot</td>
                                    <td>25.000 lot</td>
                                </tr>
                                <tr>
                                    <td>Settlement Method</td>
                                    <td colspan="2">Cash Settlement</td>
                                </tr>
                                <tr>
                                    <td>Rate (based on Clearing - ICH)</td>
                                    <td colspan="2">USD Floating</td>
                                </tr>
                                <tr>
                                    <td>Commission Charge</td>
                                    <td>USD 3 per lot/side</td>
                                    <td>USD 1 per lot/side</td>
                                </tr>
                                <tr>
                                    <td>Margin Deposit</td>
                                    <td>IDR 10.000.000</td>
                                    <td>IDR 1.000.000</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="page">
            <div class="subpage">
                <div class="content-table">
                    <h6 class="text-center mb-4">GOLD CONTRACT SPECIFICATION</h6>
                    <!-- <iframe src="../brosur-metatrader5.pdf" frameborder="0"></iframe> -->
                    <!-- <fieldset class="attachment__content">
            <iframe src="../brosur-metatrader5.pdf"> </iframe>
          </fieldset> -->

                    <!-- <embed src="../brosur-metatrader5.pdf" type="application/pdf" width="100%" height="100%" /> -->
                    <div class="text-center brosur">
                        <img src="../leflategofx.jpg" alt="" width="650" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import axios from "axios";
export default {
    props: {
        fullName: String,
        dataPrint: Object,
    },
    data() {
        return {
            currentDate: "",
            customer_complaints_settlement: "",
            scriptPDF: "",
        };
    },
    created() {
        if (this.dataPrint.tanggal_diterima) {
            this.currentDate = this.dataPrint.tanggal_diterima;
        } else {
            this.currentDate = new Date();
        }
    },
    methods: {
        customerComplaint(e) {
            this.customer_complaints_settlement = e.target.value;
            this.$emit("selectCustomerComplaint", this.customer_complaints_settlement);
            this.$root.$emit("selectCustomerComplaint", this.customer_complaints_settlement);
        },
    },
};
</script>

<style scoped>
.tanda-tangan {
    margin: -70px -45px 0;
    width: 253px;
}

.page {
    padding: 20px;
    border-radius: 5px;
    background: white;
    position: relative;
    color: black;
}

.radio {
    margin: 0 60px 0 -10px;
    line-height: 35px;
}

.radio .inner {
    width: 11px;
    height: 11px;
}

.radio .outer {
    width: 15px;
    height: 15px;
}

.label {
    width: 130px;
    margin-right: 15px;
}

.uppercase {
    text-transform: lowercase;
}

.uppercase:first-letter,
.uppercase:first-line {
    text-transform: capitalize;
}

.wrap-document {
    width: 90%;
    margin: auto;
    padding: 30px 50px;
    /* border-style: outset; */
}

.top {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
}

.header {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    margin-bottom: 25px;
}

.nomor {
    font-weight: bold;
}

.lampiran p {
    margin: 0;
    text-align: right;
}

.title {
    font-weight: bold;
    text-align: center;
    margin: 0px auto 1.5rem;
    font-size: 14px;
    width: 70%;
}

.perjanjian {
    text-align: center;
    border: solid 2px #4a4a4a;
    padding: 10px 30px;
    margin: 0 0 30px;
}

.content {
    font-size: 11.5px;
    text-align: justify;
}

.content-table {
    font-size: 10px;
}

.content-table table td {
    padding: 0.3rem 0.3rem;
    text-align: center;
    vertical-align: middle;
}

.content-table table td:nth-child(1) {
    text-align: left;
}

.menu {
    font-weight: bold;
    margin-bottom: 5px;
}

.sub-menu {
    font-weight: normal;
}

form {
    margin: 20px 0;
    text-align: right;
    font-weight: 700;
}

ol {
    margin-left: 18px;
}

.penutup {
    /* text-align: center; */
    font-size: 12px;
}

.penutup p {
    margin: 0;
}

.resiko {
    font-weight: 700;
}

.persetujuan {
    /* width: 60%; */
    font-size: 12px;
    margin: 30px 0 90px;
}

.persetujuan div {
    display: flex;
    justify-content: space-between;
}

.persetujuan p {
    width: 180px;
    text-align: center;
    margin-bottom: 0;
}

.persetujuan div form {
    margin: 0;
    font-weight: normal;
}

.tanggal {
    margin-left: auto;
    margin-bottom: 10px !important;
}

.jabatan {
    margin-bottom: 70px !important;
}

.pt-abi {
    display: block !important;
    margin: 20px auto;
    width: 50%;
}

.pt-abi p {
    width: auto !important;
}

.footer {
    display: flex;
    font-size: 10px;
    justify-content: space-between;
    position: absolute;
    width: 90%;
    bottom: 10px;
}

.ttd img {
    height: 5rem;
}

@page {
    size: A4;
    margin: 0;
}

@media (max-width: 768px) {
    .wrap-document {
        width: 100%;
        padding: 30px 0;
    }

    .page{
        padding: 0;
    }

    .title {
        margin: 20px auto !important;
    }

    .brosur img {
        width: 100%;
    }
}
</style>
